import React,{Component,Fragment} from 'react';
import './Navbar.css';
import {Link} from 'react-router-dom';
import logoblue from '../../../image/logoblue.png'

class Navbar extends Component{
    render(){
        return(
            <div>
                <nav className="navbar navbar-expand-lg color-md fixed-top  colornav" >
                        <div className="container">
                        <Link to="/"><img className="logo" src={logoblue} alt="kayn"/></Link>       

                            <button className="navbar-toggler navbar-dark " type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNav">
                                <ul className="navbar-nav ml-auto text-uppercase">
                                    <li className="nav-item active">
                                        <Link className="nav-link" to="/#Feautures">Feautures<span className="sr-only">(current)</span></Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/#Howitwork">How it work</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/#Reviews">Reviews</Link>
                                    </li>
                                    {(localStorage.getItem("userToken")?
                                    <Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/Orders">Orders</Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link" to={"/AR"+window.location.pathname} >AR</Link>
                                    </li>
                                    </Fragment>
                                    :(localStorage.getItem("AdminTokenKayn")?
                                    <Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/Admin/Orders">Orders</Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link" to={"/AR"+window.location.pathname} >AR</Link>
                                    </li>
                                    </Fragment>
                                     :
                                     <Fragment>
                                     <li className="nav-item">
                                         <Link className="nav-link" to="/SignUp">SignUp</Link>
                                     </li>
                                     <li className="nav-item">
                                         <Link className="nav-link" to="/SignIn">SignIn</Link>
                                     </li>
                                     <li className="nav-item">
                                     <Link className="nav-link" to={"/AR"+window.location.pathname} >AR</Link>
                                     </li>
                                     </Fragment>))}
                                </ul>
                            </div>
                        </div>
                    </nav> 

            </div>
        )
    }
}
export default Navbar;